var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "post__click o-grid--center u-width-8/12 u-width-10/12@l u-width-full@m",
    },
    [
      _vm.post.network_id !== _vm.$simpleStore.Networks.DY &&
      (_vm.post.thumbnail ||
        (_vm.post.uri && _vm.post.network_id === _vm.$simpleStore.Networks.IN))
        ? _c(
            "div",
            { staticClass: "o-grid__item u-width-full u-align-center" },
            [
              _vm.post.network_id === _vm.$simpleStore.Networks.YT
                ? _c(
                    "div",
                    {
                      staticClass: "c-video-wrapper",
                      attrs: { "data-id": "1" },
                    },
                    [
                      _c("youtube", {
                        ref: "youtube",
                        attrs: {
                          "video-id": _vm.post.youtube_ref,
                          "player-vars": _vm.youtubeConfig,
                          width: "1024",
                          height: "576",
                          resize: true,
                        },
                        on: { playing: _vm.playing },
                      }),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.FB &&
                  _vm.post.type != null &&
                  _vm.post.type.indexOf("video") !== -1
                ? _c("div", {
                    staticClass: "video-iframe",
                    style: _vm.aspectRatio,
                    attrs: { "data-id": "2" },
                    domProps: { innerHTML: _vm._s(_vm.post.source) },
                  })
                : _vm.post.network_id === _vm.$simpleStore.Networks.FB &&
                  _vm.post.type === "album" &&
                  typeof _vm.post.media_attachments === "object"
                ? _c(
                    "div",
                    { ref: "fbSlides", staticClass: "fb-slides" },
                    [
                      _c(
                        "VueSlickCarousel",
                        {
                          attrs: {
                            adaptiveHeight: false,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 2500,
                            draggable: false,
                            infinite: false,
                            "data-id": "3",
                          },
                        },
                        _vm._l(
                          _vm.post.media_attachments,
                          function (slide, index) {
                            return _c("img", {
                              attrs: {
                                src: slide.src,
                                alt: "slide image",
                                id: "slide-" + index,
                              },
                              on: {
                                error: (event) =>
                                  _vm.updateSlide(event, _vm.post),
                              },
                            })
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type === "carousel_album" &&
                  _vm.post.media_attachments &&
                  typeof _vm.post.media_attachments === "object"
                ? _c(
                    "div",
                    { ref: "inSlides", staticClass: "in-slides" },
                    [
                      _c(
                        "VueSlickCarousel",
                        {
                          attrs: {
                            adaptiveHeight: true,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 2500,
                            draggable: false,
                            infinite: false,
                            "data-id": "4",
                          },
                        },
                        _vm._l(
                          _vm.post.media_attachments,
                          function (slide, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "slick-slide-wrapper",
                              },
                              [
                                slide.type === "IMAGE" || !slide.type
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        display: "block",
                                      },
                                      attrs: {
                                        src: slide.src,
                                        alt: "slide image",
                                        id: "slide-" + index,
                                      },
                                      on: {
                                        error: (event) =>
                                          _vm.updateSlide(event, _vm.post),
                                      },
                                    })
                                  : slide.type === "VIDEO"
                                  ? _c("video", {
                                      staticStyle: {
                                        width: "100%",
                                        display: "block",
                                      },
                                      attrs: {
                                        src: slide.src,
                                        controls: "",
                                        id: "slide-" + index,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                slide.type === "VIDEO"
                                  ? _c(
                                      "div",
                                      { staticClass: "video-overlay" },
                                      [
                                        _c("img", {
                                          staticClass: "play-icon",
                                          attrs: {
                                            src: _vm.$cdn(
                                              "/img2.0/icons/play.svg"
                                            ),
                                            alt: "video",
                                            width: "34",
                                            height: "39",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.TW &&
                  typeof _vm.post.videoData != "undefined"
                ? _c(
                    "video",
                    {
                      attrs: {
                        width: _vm.post.media_width
                          ? _vm.post.media_width
                          : "100%",
                        poster: _vm.post.videoData.thumbnailUrl,
                        controls: "",
                        "data-id": "5",
                      },
                    },
                    [
                      _c("source", {
                        attrs: {
                          src: _vm.post.videoData.videoUrl,
                          type: "video/mp4",
                        },
                      }),
                    ]
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type !== "video"
                ? _c("img", {
                    staticClass: "instagram-image",
                    attrs: {
                      src: _vm.post.uri,
                      alt: _vm.post.community_name + " article image",
                      "data-id": "6",
                    },
                  })
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type === "video" &&
                  _vm.post.uri == null
                ? _c("div", { staticClass: "instagram-wrapper" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.instagramEmbed) },
                    }),
                  ])
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type === "video"
                ? _c("div", { staticClass: "instagram-video-wrapper" }, [
                    _c(
                      "video",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showINVideo,
                            expression: "showINVideo",
                          },
                        ],
                        ref: "videoInstagram",
                        attrs: {
                          width: _vm.post.media_width
                            ? _vm.post.media_width
                            : "100%",
                          controls: "",
                          "data-id": "7",
                        },
                        on: {
                          canplaythrough: function ($event) {
                            _vm.showINVideo = true
                          },
                        },
                      },
                      [
                        _c("source", {
                          attrs: { src: _vm.post.uri, type: "video/mp4" },
                          on: {
                            error: (event) => _vm.updatePost(event, _vm.post),
                          },
                        }),
                      ]
                    ),
                  ])
                : _c("img", {
                    attrs: {
                      src: _vm.$simpleStore.transformImageWithCloudfront(
                        812,
                        null,
                        _vm.post.thumbnail,
                        _vm.$root
                      ),
                      srcset: _vm.$simpleStore.transformImageWithCloudfront(
                        812,
                        null,
                        _vm.post.thumbnail,
                        _vm.$root,
                        "srcset"
                      ),
                      alt: _vm.post.community_name + " article image",
                      width: "812",
                      "data-id": "8",
                    },
                  }),
            ]
          )
        : _vm.post.network_id === _vm.$simpleStore.Networks.DY &&
          (_vm.post.thumbnail || _vm.post.youtube_id || _vm.post.media)
        ? _c(
            "div",
            {
              staticClass: "o-grid__item u-width-full u-align-center",
              staticStyle: { "min-height": "250px" },
            },
            [
              _vm.post.thumbnail
                ? [
                    _c(
                      "figure",
                      { staticClass: "image", attrs: { id: "thumbnail" } },
                      [
                        _c("img", {
                          class: _vm.post.hero_size,
                          attrs: {
                            src: _vm.$simpleStore.transformImageWithCloudfront(
                              812,
                              null,
                              _vm.post.thumbnail,
                              _vm.$root
                            ),
                            srcset:
                              _vm.$simpleStore.transformImageWithCloudfront(
                                812,
                                null,
                                _vm.post.thumbnail,
                                _vm.$root,
                                "srcset"
                              ),
                            alt: _vm.post.community_name + " article image",
                            width: "812",
                            "data-id": "9",
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm.post.youtube_id
                ? [
                    _c(
                      "div",
                      { staticClass: "c-video-wrapper" },
                      [
                        _c("youtube", {
                          ref: "youtube",
                          attrs: {
                            "video-id": _vm.post.youtube_id,
                            "player-vars": _vm.youtubeConfig,
                            width: "1024",
                            height: "576",
                            resize: "true",
                            "data-id": "10",
                          },
                          on: { playing: _vm.playing },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm.post.media
                ? _c("div", { domProps: { innerHTML: _vm._s(_vm.post.media) } })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "o-grid__item u-width-full" }, [
        _c(
          "div",
          { staticClass: "post__bottom" },
          [
            _c(
              "div",
              {
                directives: [
                  { name: "twitteremoji", rawName: "v-twitteremoji" },
                ],
                ref: "postContent",
                class: [
                  "post__content",
                  _vm.post.user_id != null ? "post__content__ugc" : "",
                ],
              },
              [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$simpleStore.highlightHashtags(
                        _vm.post.content,
                        _vm.post.community_url
                      )
                    ),
                  },
                }),
                _vm._v(" "),
                typeof _vm.post.embeddedTweet != "undefined"
                  ? _c("div", { staticClass: "tweet" }, [
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "profile" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.post.embeddedTweet.profile_image,
                              alt: "profile image",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.post.embeddedTweet.link,
                                target: "_blank",
                              },
                            },
                            [_vm._v("@" + _vm._s(_vm.post.embeddedTweet.user))]
                          ),
                          _vm._v(
                            "\n                            ·\n                            " +
                              _vm._s(_vm.post.embeddedTweet.date) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(_vm.post.embeddedTweet.text),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.post.embeddedTweet.media != null
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.post.embeddedTweet.link,
                                target: "_blank",
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "media",
                                attrs: {
                                  src: _vm.post.embeddedTweet.media.url,
                                  alt: "",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("like-repost-comment", {
              attrs: { "show-reposts": _vm.showReposts },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "c-comments",
              "u-hidden@s",
              this.showComments ? "show" : "",
            ],
          },
          [
            _vm.post.enable_comments
              ? [
                  _c(
                    "p",
                    { staticClass: "comments__title" },
                    [
                      _vm.commentCount !== 1
                        ? [
                            _c("span", [
                              _vm._v(_vm._s(_vm.commentCount) + " comments"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "comments__close u-hidden u-block@s",
                                on: { click: _vm.toggleComments },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 14 14",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M1 1L13 13",
                                        stroke: "black",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M13 1L1 13",
                                        stroke: "black",
                                        "stroke-width": "1.5",
                                        "stroke-linecap": "round",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm._v(
                              " " + _vm._s(_vm.commentCount) + " comment "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("post-comments-block"),
                ]
              : _c("p", { staticClass: "clear u-p-b3" }, [
                  _vm._v(
                    "\n                Comments are disabled for this post.\n            "
                  ),
                ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "comments__mobile u-hidden u-block@s",
            on: { click: _vm.toggleComments },
          },
          [
            _vm.commentCount !== 1
              ? _c("div", [
                  _vm._v(
                    "\n                View " +
                      _vm._s(_vm.commentCount) +
                      " comments\n            "
                  ),
                ])
              : _c("div", [
                  _vm._v("View " + _vm._s(_vm.commentCount) + " comment"),
                ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }